import { useAuthenticator } from "@aws-amplify/ui-react";
import { getCognitoUserAttribute } from "helpers/utils";
import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";

interface IAuthContext {
    isAdminCrealo: boolean;
}

const AuthContext = createContext<IAuthContext | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const { user } = useAuthenticator((context) => [context.user]);

    const accountType = getCognitoUserAttribute("custom:accountType", user);
    const email = user?.attributes?.email ?? "";

    const value = useMemo(
        () => ({
            isAdminCrealo: accountType === "admin" && email.includes("@crealo.app"),
        }),
        [accountType, email],
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
